export const tablefields = [
	{
		'name': 'Project',
		'order': '1',
		'value': 'title',
		'width': 200,
		'class': 'AlignLeft',
		'visible': true
	},
	{
		'name': 'Date',
		'order': '2',
		'value': 'date',
		'type': 'date',
		'version_table': '2021-12-10',
		'width': 100,
		'visible': true
	},
	{
		'name': 'Unit',
		'order': '3',
		'value': 'unit_number',
		'width': 80,
		'visible': true
	},
	{
		'name': 'Total',
		'order': '9',
		'value': 'total_cost',
		'type': 'currency',
		'width': 100,
		'class': 'AlignRight',
		'visible': true
	},
	{
		'name': 'Status',
		'order': '4',
		'value': 'se_st_name',
		'type': 'back_translate',
		'class': 'AlignLeft',
		'width': 150,
		'visible': true
	},
	{
		'name': 'Purchase order',
		'order': '10',
		'value': 'po',
		'class': 'AlignLeft',
		'visible': true
	},
	{
		'name': 'Type',
		'order': '5',
		'value': 'catering_name',
		'type': 'back_translate',
		'class': 'AlignLeft',
		'width': 200,
		'visible': true
	},
	{
		'name': 'Time',
		'order': '6',
		'value': 'time',
		'type': 'time',
		'width': 100,
		'visible': true
	},
	{
		'name': 'Quantity',
		'order': '7',
		'value': 'quantity',
		'width': 100,
		'visible': true
	},
	{
		'name': 'Unit cost',
		'order': '8',
		'value': 'cost_unit',
		'type': 'currency',
		'width': 100,
		'class': 'AlignRight',
		'visible': true
	},
	{
		'name': 'Invoice',
		'order': '11',
		'value': 'invoice',
		'class': 'AlignLeft',
		'width': 150,
		'visible': true
	},
	{
		'name': 'Files',
		'order': '12',
		'value': 'total_files',
		'width': 80,
		'visible': true
	},
	{
		'name': 'Date created',
		'order': '13',
		'value': 'created_at',
		'type': 'date',
		'width': 100,
		'visible': true
	},
	{
		'name': 'Date approved',
		'order': '13',
		'value': 'date_approved',
		'type': 'date',
		'width': 150,
		'visible': true
	},
	{
		'name': 'Date updated',
		'order': '14',
		'value': 'updated_at',
		'type': 'date',
		'width': 150,
		'visible': true
	},
]